/**
 * Service: feature
 */
angular.module('acme.common.service.feature', [
  'acme.common.service.objectLock',
  'acme.common.service.customers',
  'acme.common.service.coupons',
  'acme.common.service.themesHelper'
])
.service('FeatureService', ['ObjectLockService', 'CustomersService', 'CouponsService', 'ThemesHelperService', function(ObjectLockService, CustomersService, CouponsService, ThemesHelperService) {

    var feature = {

      objectLock: ObjectLockService,
      customers: CustomersService,
      coupons: CouponsService,

      init: function() {
        this.objectLock.init();
        this.customers.init();
        this.coupons.init();
      },

      isEnabled: function(feature) {
        var r = false;

        if (feature.name && feature.key) {
          r = ThemesHelperService.getFeaturesConfig(feature.name, feature.key);
        }

        return r;
      }

    };

    feature.init();

    return feature;

}]);
